import type { TransientConfigurationPayload } from "features/transient-response/model/transientConfiguration";

import { customApiCall } from "utils/axios";

import type {
  TechnicalDataScenario,
  TrScenarioApi,
  TrScenarioCreatePayload,
  TrScenarioCreateResponse,
  TrScenarioPatchPayload,
} from "../model/types";

import { parseTrConfigResponse, type TransientJobConfig } from "../lib/parseTrConfig";
import { mapApiScenario } from "../lib/scenarioMappers";
import { trScenarioUrls } from "./urls";

export const fetchTrScenarios = async (projectId: string): Promise<TechnicalDataScenario[]> => {
  const scenarios = (await customApiCall.get({ url: trScenarioUrls.list(projectId) })) as TrScenarioApi[];
  return scenarios.map(mapApiScenario);
};

export const createTrScenario = async (
  projectId: string,
  data: TrScenarioCreatePayload
): Promise<TechnicalDataScenario> => {
  const response = (await customApiCall.post({
    data,
    url: trScenarioUrls.list(projectId),
  })) as TrScenarioCreateResponse;
  return mapApiScenario(response.scenario);
};

export const patchTrScenario = async (
  projectId: string,
  scenarioId: number,
  data: TrScenarioPatchPayload
): Promise<TechnicalDataScenario> =>
  mapApiScenario(
    (await customApiCall.patch({ data, url: trScenarioUrls.detail(projectId, scenarioId) })) as TrScenarioApi
  );

export const deleteTrScenario = (projectId: string, scenarioId: number) =>
  customApiCall.delete({ url: trScenarioUrls.detail(projectId, scenarioId) });

export const createTrConfig = (projectId: string, data: TransientConfigurationPayload) =>
  customApiCall.post({ data, url: trScenarioUrls.config(projectId) });

export const fetchTrConfig = async (projectId: string, configId: number): Promise<TransientJobConfig> => {
  const parsed = parseTrConfigResponse(
    await customApiCall.get({ url: trScenarioUrls.configDetail(projectId, configId) })
  );
  if (!parsed) throw new Error("Missing configuration");
  return parsed;
};
